/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { get } from 'lodash'

/**
 *     Import
 *     - Components
 */
import { Button } from '../../../common/Button/Button'
import Container from '../../../common/Container/Container'
import HeaderContainer from '../../../common/HeaderContainer/HeaderContainer'
import PopUp from '../../../common/PopUp/PopUp'
import AddressBlock from '../../Quote/Step02/components/AddressBlock'
import DatePicker from '../../../common/DatePicker/DatePicker'
import { getSettlementBasis, settlementBasisCalc } from '../../../common/SettlementBasis'
// import Mta from './MtaPopUp'

/**
 *     Import
 *     - Styles
 */
import './styles/ViewPolicies.css'

export default class ViewPolicy extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            renewPolicyPopUp: {
                show: false,
            },
            showSubjMarkAsCompPopUp: false,
            requestedExtensionPopUp: false,
            cancelPolicyPopUp: false,
            cancelPolicyPopUpTextArea: '',
            cancelPolicyPopUpDate: '',
            cancelPolicyPopUpTextAreaError: false,
            cancelPolicyPopUpDateError: false,
            addMtaPopUp: false,
            emailPopUp: false,
            policyAddress: null,
        }
    }

    componentDidMount() {
        this.props.getPolicySingle(this.props.match.params.policyId)
        this.props.getSubjectivity(this.props.match.params.policyId)
        this.props.getPolicyMTA(this.props.match.params.policyId)
    }

    componentWillReceiveProps(nextProps: any) {
        if (nextProps.subjectivities.markSubjectivitiesAsCompleted.done) {
            nextProps.subjectivities.markSubjectivitiesAsCompleted.done = false
            this.setState({ showSubjMarkAsCompPopUp: true })
            this.props.getSubjectivity(this.props.match.params.policyId)
        }
        if (nextProps.subjectivities.extend.done) {
            nextProps.subjectivities.extend.done = false
            this.setState({ requestedExtensionPopUp: true })
            this.props.getSubjectivity(this.props.match.params.policyId)
        }
    }

    handleEdit = () => {
        return true
    }

    columnChunks = (arr, size) => {
        if (!Array.isArray(arr)) {
            throw new TypeError('Input should be Array')
        }

        if (typeof size !== 'number') {
            throw new TypeError('Size should be a Number')
        }

        let result: any = []
        for (let i = 0; i < arr.length; i += size) {
            result.push(arr.slice(i, size + i))
        }

        return result
    }

    handleRenew = () => {
        this.setState({
            renewPolicyPopUp: {
                show: true,
                renewId: this.props.match.params.policyId,
            },
        })
    }

    handleDownload = () => {
        this.props.downloadPolicyScheme(this.props.match.params.policyId)
        this.setState({ emailPopUp: false })
    }

    handleCancelPolicy = () => {
        if (this.state.cancelPolicyPopUpTextArea !== '' && this.state.cancelPolicyPopUpDate !== '') {
            this.props.cancelPolicy(
                this.props.match.params.policyId,
                this.state.cancelPolicyPopUpTextArea,
                this.state.cancelPolicyPopUpDate)
            this.setState({
                cancelPolicyPopUp: false, cancelPolicyPopUpTextAreaError: false,
                cancelPolicyPopUpDateError: false,
            })
        } else {
            if (this.state.cancelPolicyPopUpTextArea === '') {
                this.setState({ cancelPolicyPopUpTextAreaError: true})
            }
            if (this.state.cancelPolicyPopUpDate === '') {
            this.setState({cancelPolicyPopUpDateError: true })
            }
        }
    }

    handleRequestExtension = () => {
        this.props.extendSubjectivity(this.props.match.params.policyId)
    }

    handleMarkSubCompleted = () => {
        this.props.markSubjectivityAsCompleted(this.props.match.params.policyId)
        // this.props.getSubjectivity(this.props.match.params.policyId)
    }

    handleMta = () => {
        this.setState({ addMtaPopUp: !this.state.addMtaPopUp })
    }

    handleMtaContinue = () => {
        this.props.history.push('/clients/policies/mta/' + this.props.match.params.policyId)
    }

    handleCancelPolicyClose = () => {
        this.setState({ cancelPolicyPopUp: false })
    }

    closeSubjMarkAsCompPopUp = () => {
        this.setState({ showSubjMarkAsCompPopUp: false })
    }

    closeRequestedExtensionPopUp = () => {
        this.setState({ requestedExtensionPopUp: false })
    }

    getSumInsuredTitle = () => {
        const { policy } = this.props

        if (get(policy, 'response.isCollectors', false)) {
            return 'Collection sum insured'
        } else if (get(policy, 'response.isMuseums', false)) {
            return 'Total Exhibits sum insured'
        } else if (get(policy, 'response.isDealersStock', false)) {
            return 'Total dealers stock sum insured'
        } else if (get(policy, 'response.isWineSpirits', false)) {
            return 'Total Collection sum insured'
        } else if (get(policy, 'response.isCommercialProperty', false)) {
            return 'Total delcared value'
        } else {
            return 'Total stock sum insured'
        }
    }

    render() {
        const { fullPolicy } = this.props
        let policy = this.props.policy.response
        let fullPolicys = get(fullPolicy, 'response.riskLocations')
        const operativeSections = this.columnChunks(policy.operativeSections, 5)
        return (
            <div
                className={`policy ${(policy.policyName !== undefined && ((policy.policyName === 'Collectors' ||
                    policy.isCollectors) || policy.isMuseums || policy.isWineSpirits)) ?
                    'RiskAddress' : null}`}
            >
                {(this.state.renewPolicyPopUp.show) ?
                    <div className="">
                        <PopUp
                            title={'Renew Policy'}
                            action={() => this.props.history
                                .push(`/renewals/bind/${this.state.renewPolicyPopUp.renewId}`)}
                            buttonText={'Renew as is'}
                            numberButtons={3}
                            secondaryAction={() => {
                                this.props.history
                                    .push(`/renewals/edit/${this.state.renewPolicyPopUp.renewId}`)

                            }}
                            secondaryButtonText={'Edit details'}
                            thirdAction={() => { this.setState({ renewPolicyPopUp: { show: false } }) }}
                            thirdButtonText={'Back'}
                        >
                            In order to renew this policy please select whether you would like to renew on
                            existing details or edit the details. You can also download a PDF copy to send
                            to your client.
                            <div className="download_pdf_policy">
                                Download pdf policy form
                            </div>
                        </PopUp>
                    </div>
                    : null}
                {(this.state.addMtaPopUp) ?
                    <div className="addMta">
                        <PopUp
                            title="Add Mid Term Adjustment"
                            action={() => { this.handleMtaContinue() }}
                            buttonText="Continue"
                            secondaryAction={() => { this.handleMta() }}
                            secondaryButtonText="Cancel"
                        >
                            <div style={{ padding: 20 }}>
                                Are you sure you want to add an MTA?
                            </div>
                        </PopUp>
                    </div>
                    : null}
                {(this.state.showSubjMarkAsCompPopUp) ?
                    <PopUp
                        title="Subjectivities Marked as Completed"
                        action={() => { this.closeSubjMarkAsCompPopUp() }}
                        buttonText="OK"
                    >
                        Your subjectiities has been marked as completed.
                    </PopUp>
                    : null
                }
                {(this.state.emailPopUp) ?
                    <PopUp
                        title="Email Schedule"
                        action={() => { this.handleDownload() }}
                        buttonText="Continue"
                        secondaryAction={() => { this.setState({ emailPopUp: false }) }}
                        secondaryButtonText="Cancel"
                    >
                        Do you want to email the schecule?
                    </PopUp>
                    : null
                }
                {(this.props.subjectivities.cancelPolicy.done) ?
                    <PopUp
                        title="Cancel Policy"
                        action={() => {
                            this.props.subjectivities.cancelPolicy.done = false
                            this.props.getPolicySingle(this.props.match.params.policyId)
                            this.props.getSubjectivity(this.props.match.params.policyId)
                        }}
                        buttonText="OK"
                    >
                        {!this.props.subjectivities.cancelPolicy.error ?
                            'Cancellation has been requested' :
                            'There\'s been an error, please try again later'
                        }
                    </PopUp>
                    : null
                }
                {(this.state.cancelPolicyPopUp) ?
                    <div
                        className={`cancelPolicyPopUp ${(this.state.cancelPolicyPopUpTextAreaError) ? 'error' : ''}
                         ${(this.state.cancelPolicyPopUpDateError ? 'additionalError' : '')}`}
                    >
                        <PopUp
                            title="Are you sure?"
                            action={() => { this.handleCancelPolicy() }}
                            buttonText="Yes"
                            secondaryAction={() => this.handleCancelPolicyClose()}
                            secondaryButtonText="No"
                        >
                            <div className={`cancelPolicyPopUpText`}>
                                Are you sure you want to cancel the policy <strong>{policy.policyNumber}</strong>?
                            </div>
                            <div className="calanderDate">
                                <div className="calendar w100">
                                    <DatePicker
                                        placeholder="Cancel Policy Date"
                                        onChange={(date) => {
                                            this.setState({
                                                cancelPolicyPopUpDate: date,
                                                cancelPolicyPopUpDateError: !date,
                                            })
                                        }}
                                        cancelPolicyDate={policy.expiryDate}
                                        onFocus={() => null}
                                    />
                                </div>
                                <div className="errorDate">
                                    A date is required for canceling a policy
                                </div>
                            </div>
                            <textarea
                                className="cancelPolicyTeaxArea"
                                placeholder="What is the reason of canceling the policy?"
                                onChange={(text) => {
                                    this.setState(
                                        {
                                            cancelPolicyPopUpTextArea: text.target.value,
                                            cancelPolicyPopUpTextAreaError: !text.target.value,
                                        }
                                    )
                                }}
                            />
                            <div className="errorText">
                                A reason is required for canceling a policy
                            </div>
                        </PopUp>
                    </div>
                    : null
                }
                {(this.state.requestedExtensionPopUp) ?
                    <PopUp
                        title="Requested Extension"
                        action={() => { this.closeRequestedExtensionPopUp() }}
                        buttonText="OK"
                    >
                        You have requested an extension.
                    </PopUp>
                    : null
                }
                <HeaderContainer
                    className="policy__header"
                    fullwidth={true}
                    titles={['Policy Details']}
                    back={true}
                    backAction={() => this.props.history.goBack()}
                >
                    {
                        !policy.cancellationPending && !policy.cancelled &&
                        <div
                            className="policy__cancel"
                            onClick={() => this.setState({ cancelPolicyPopUp: true })}
                        >Cancel policy
                        </div>
                    }
                </HeaderContainer>

                {policy.cancellationPending &&
                    <Container className="subjectivities" fullwidth={false}>
                        <div>
                            <div className="subjectivities__header">
                                <span>Policy cancellation requested</span>
                            </div>
                        </div>
                    </Container>
                }

                {policy.cancelled &&
                    <Container className="subjectivities" fullwidth={false}>
                        <div>
                            <div className="subjectivities__header">
                                <span>Policy cancelled</span>
                            </div>
                        </div>
                    </Container>
                }

                {
                    (this.props.subjectivities.subjectivities.done &&
                        this.props.subjectivities.subjectivities.response.subjectivities.length) ?
                        <Container className="subjectivities" fullwidth={false}>
                            <div>
                                <div className="subjectivities__header">
                                    <span>Subjectivity warning: </span>
                                    This policy is subject to the following conditions
                                </div>
                                <div className="subjectivities__content">
                                    <div className="subjectivities__days">
                                        {this.props.subjectivities.subjectivities.response.daysRemaining} days remaining
                                    </div>

                                    {this.props.subjectivities.subjectivities.done &&
                                        this.props.subjectivities.subjectivities.response.subjectivities.map((i, e) => {
                                            return (
                                                <div className="subjectivities__reason" key={i}>
                                                    <span>{i.title}: </span> {i.description}
                                                </div>
                                            )
                                        })}
                                </div>

                                <div className="subjectivities__actions">
                                    <Button
                                        className="subjectivities__actions__extension"
                                        onClick={this.handleRequestExtension}
                                    >
                                        Request extension
                                    </Button>
                                    <Button
                                        className={
                                            `subjectivities__actions__mark
                                            ${this.props.subjectivities.subjectivities.response.markCompleted ?
                                                ' disabled' :
                                                ''
                                            }`
                                        }
                                        onClick={this.handleMarkSubCompleted}
                                        disabled={this.props.subjectivities.subjectivities.response.markCompleted}
                                    >
                                        Mark subjectivities as completed
                                    </Button>
                                </div>
                            </div>
                        </Container>
                        :
                        null
                }

                <Container className="summary" fullwidth={false}>

                    <div className="summary__box">
                        <div className="summary__header">
                            <div className="summary__header__title">
                                {policy.clientName}
                            </div>
                            <div className="summary__header__subtitle">
                                {policy.policyName} Policy
                            </div>
                            <div className="summary__header__policyInfo">
                                Policy no. <span>{policy.policyNumber}</span>
                            </div>
                        </div>
                        <div className="summary__row">
                            <div className="summary__infoBlock">
                                <div className="summary__infoBlock__title">Inception date</div>
                                <div className="summary__infoBlock__value"><span>{policy.inceptionDate}</span></div>
                            </div>
                            <div className="summary__infoBlock">
                                <div className="summary__infoBlock__title">Expiry date</div>
                                <div className="summary__infoBlock__value"><span>{policy.expiryDate}</span></div>
                            </div>
                            <div className="summary__infoBlock">
                                <div className="summary__infoBlock__title">Premium</div>
                                <div className="summary__infoBlock__value">
                                    <span>
                                        {/* {(Number(policy.premium)).toLocaleString('en-GB', {
                                            style: 'currency',
                                            currency: 'GBP',
                                        })} */}
                                        £{policy.premium}
                                    </span> inc.IPT
                                </div>
                            </div>

                        </div>
                        {
                            (!policy.manual) ?
                                <div className="summary__row">
                                    <div className="summary__infoBlock">
                                        <div className="summary__infoBlock__title">Your commission</div>
                                        <div className="summary__infoBlock__value">
                                            <span>{policy.commission}%</span>
                                        </div>
                                    </div>
                                    <div className="summary__infoBlock">
                                        <div className="summary__infoBlock__title">Excess</div>
                                        <div className="summary__infoBlock__value">
                                            <span>
                                                {/* £{policy.excess} */}
                                                {(typeof (policy.excess) === 'number') ?
                                                    (policy.excess).toLocaleString('en-GB', {
                                                        style: 'currency',
                                                        currency: 'GBP',
                                                    })
                                                    :
                                                    `£${policy.excess}`}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="summary__infoBlock">
                                        <div className="summary__infoBlock__title">
                                            {this.getSumInsuredTitle()}
                                        </div>
                                        <div className="summary__infoBlock__value">
                                            <span>
                                                {/* {(Number(policy.totalSumInsured)).toLocaleString('en-GB', {
                                                    style: 'currency',
                                                    currency: 'GBP',
                                                })} */}
                                                £{policy.totalSumInsured}
                                            </span>
                                        </div>
                                    </div>
                                    {(policy.policyName !== undefined && ((policy.policyName === 'Collectors' ||
                                        policy.isCollectors) || policy.isMuseums || policy.isWineSpirits ||
                                        policy.isCommercialProperty)) ?
                                        null : <div className="summary__infoBlock">
                                            <div className="summary__infoBlock__title">Settlement basis</div>
                                            <div className="summary__infoBlock__value">
                                                <span>
                                                    {getSettlementBasis(policy.priceBasis, policy.settlementBasis)}
                                                    {settlementBasisCalc(policy.settlementBasis)}%
                                                </span>
                                            </div>
                                        </div>
                                    }
                                </div>
                                :
                                null
                        }
                        {
                            (!policy.manual) ?
                                <div className="summary__row">
                                    <div className="summary__infoBlock__value">
                                        <span>
                                            {(policy.policyName !== undefined && ((policy.policyName === 'Collectors' ||
                                                policy.isCollectors) || policy.isMuseums || policy.isWineSpirits) &&
                                                fullPolicys) ?
                                                'Risk Addresses' : 'Operative sections'
                                            }
                                        </span>
                                    </div>
                                    {(policy.policyName &&
                                        (policy.policyName === 'Collectors' || policy.isCollectors
                                            || policy.isMuseums || policy.isWineSpirits)
                                        && fullPolicys) ?
                                        // fullPolicys.map((e, i) => <div>{e.addressType}</div>)
                                        <div className="PolicyAddressShow">
                                            {fullPolicys.map((r, i) => {
                                                return (
                                                    <AddressBlock
                                                        key={i}
                                                        id={r.id}
                                                        quoteId={parseInt(this.props.match.params.id, 10)}
                                                        addressType={r.addressType}
                                                        addressLine1={r.addressLine1}
                                                        addressLine2={r.addressLine2}
                                                        city={r.city}
                                                        postcode={r.postcode}
                                                        addressAllocated={r.allocated}
                                                    />
                                                )
                                            })}
                                        </div>
                                        :
                                        operativeSections.map((row, i) => (
                                            <div key={i} className="summary__infoBlock">
                                                {
                                                    row.map((col, y) => (
                                                        <div key={y} className="summary__infoBlock__value">{col}</div>
                                                    ))
                                                }
                                            </div>
                                        ))

                                    }
                                    {/* {operativeSections.map((row, i) => (
                                        <div key={i} className="summary__infoBlock">
                                            {
                                                row.map((col, y) => (
                                                    <div key={y} className="summary__infoBlock__value">{col}</div>
                                                ))
                                            }
                                        </div>
                                    ))
                                    } */}
                                </div>
                                :
                                null
                        }
                        {
                            policy.mtas && policy.mtas.map((mta, i) => (
                                <div className="mtas__row" key={i}>
                                    <div className="mtas__infoBlock__value"><span>{mta.title}</span></div>
                                    <div className="mtas__infoBlock__content">
                                        <div className="mtas__infoBlock__premium">
                                            New Annual Premium: £{mta.premium}
                                        </div>
                                        <div className="mtas__infoBlock__dates">
                                            <div className="mtas__infoBlock__dates--effective">
                                                Effective date: {mta.effectiveDate}
                                            </div>
                                            <div className="mtas__infoBlock__dates--expiry">
                                                Expiry date: {mta.expiryDate}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>

                    <div className="summary__actions">
                        <Button
                            className="summary__action__renew"
                            onClick={() => { this.handleRenew() }}
                            disabled={
                                policy.cancellationPending || policy.cancelled || policy.manual ||
                                policy.renewalBind || !policy.renewalAvailable
                            }
                        >
                            {policy.renewalBind ? 'Renewed' : 'Renew policy'}
                        </Button>

                        <Button
                            className="summary__action__download"
                            onClick={() => this.setState({ emailPopUp: true })}
                        >
                            email schedule
                        </Button>

                        <Button
                            className="summary__action__mta"
                            onClick={this.handleMta}
                            disabled={policy.cancellationPending || policy.cancelled || policy.manual}
                        >
                            Add mid term ajustment
                        </Button>

                    </div>

                </Container>
            </div >
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Policies/View/View.tsx